// extracted by mini-css-extract-plugin
module.exports = {"ProductActionsUIWrapper":"ProductActionsUI_ProductActionsUIWrapper__poMX_"};